module.exports = __webpack_public_path__ + "static/media/ZecTelecom-logos_white.3071e1b6.png";